import testConfig from "./test.config";
import prodConfig from "./prod.config";

export default !import.meta.env.PROD ? testConfig : prodConfig;
